module.exports = __webpack_public_path__ + "media/packs/images/flags/BS-6d208a499524c23c74505f2ba947f824.png";